export function getUserContactFromApprovedUser({
  peopleInThisBrandData,
  staffUserId,
  mentorsInThisBrandData,
  role = 'ROLE_DOCTOR',
}) {
  const personSummary = peopleInThisBrandData?.find((item) => item?.userId === staffUserId)
  let contact = null
  if (personSummary) {
    contact = {
      id: mentorsInThisBrandData?.find((item) => item?.userId === personSummary?.userId)?.id,
      uid: mentorsInThisBrandData?.find((item) => item?.userId === personSummary?.userId)?.id,
      userId: personSummary?.userId,
      email: personSummary?.email || '',
      role: role,
      title: personSummary?.name || personSummary?.firstName,
      profilePicId: personSummary?.profilePicId,
    }
  }
  return contact
}

export function getUserContactFromProspectUser({ prospectContact, role }) {
  return {
    ...prospectContact,
    role: role,
  }
}

export function getAllContactsOfAClinicBrand({
  clinicBrandData,
  mentorsInThisBrandData,
  peopleInThisBrandData,
}) {
  let toReturnObject = { doctors: [], therapists: [], assistants: [] }

  // adding approved brand doctors in the list:
  const attachedDoctorUserIds = (clinicBrandData?.workforce?.doctors || [])?.map(
    (doc) => doc?.userId,
  )
  attachedDoctorUserIds.forEach((doctorUserId) => {
    const docContact = getUserContactFromApprovedUser({
      mentorsInThisBrandData,
      peopleInThisBrandData,
      staffUserId: doctorUserId,
      role: 'ROLE_DOCTOR',
    })

    if (docContact) {
      toReturnObject = { ...toReturnObject, doctors: [...toReturnObject?.doctors, docContact] }
    }
  })

  // adding unapproved brand doctors in the list:
  const prospectDoctorContacts = clinicBrandData?.prospects?.doctors || []
  prospectDoctorContacts?.forEach((doctorContact) => {
    let thisDoctor = getUserContactFromProspectUser({
      prospectContact: doctorContact,
      role: 'ROLE_DOCTOR',
    })
    toReturnObject = { ...toReturnObject, doctors: [...toReturnObject?.doctors, thisDoctor] }
  })

  // adding approved therapists in the list:
  const workForceTherapistUserIds = (clinicBrandData?.workforce?.therapists || [])?.map(
    (therapist) => therapist?.userId,
  )
  workForceTherapistUserIds.forEach((therapistUserId) => {
    const therapistContact = getUserContactFromApprovedUser({
      mentorsInThisBrandData,
      peopleInThisBrandData,
      staffUserId: therapistUserId,
      role: 'ROLE_THERAPIST',
    })

    if (therapistContact) {
      toReturnObject = {
        ...toReturnObject,
        therapists: [...toReturnObject?.therapists, therapistContact],
      }
    }
  })

  // adding unapproved brand therapists in the list:
  const prospectTherapistContacts = clinicBrandData?.prospects?.therapists || []
  prospectTherapistContacts.forEach((contact) => {
    let thisTherapist = getUserContactFromProspectUser({
      prospectContact: contact,
      role: 'ROLE_THERAPIST',
    })
    toReturnObject = {
      ...toReturnObject,
      therapists: [...toReturnObject?.therapists, thisTherapist],
    }
  })

  // adding approved clinic assistants in the list:
  const workforceClinicAssistantUserIds = (clinicBrandData?.workforce?.clinicAssistants || [])?.map(
    (assistant) => assistant?.userId,
  )

  workforceClinicAssistantUserIds.forEach((assistantUserId) => {
    const assistantContact = getUserContactFromApprovedUser({
      mentorsInThisBrandData,
      peopleInThisBrandData,
      staffUserId: assistantUserId,
      role: 'ROLE_CLINIC_ASSISTANT',
    })

    if (assistantContact) {
      toReturnObject = {
        ...toReturnObject,
        assistants: [...toReturnObject?.assistants, assistantContact],
      }
    }
  })

  // adding unapproved brand doctors in the list:
  const prospectClinicAssistantContacts = clinicBrandData?.prospects?.clinicAssistants || []
  prospectClinicAssistantContacts.forEach((contact) => {
    let thisAssistant = getUserContactFromProspectUser({
      prospectContact: contact,
      role: 'ROLE_CLINIC_ASSISTANT',
    })
    toReturnObject = {
      ...toReturnObject,
      assistants: [...toReturnObject?.assistants, thisAssistant],
    }
  })

  return toReturnObject
}

export function isClinicStaffAlreadyAdded({ userContactData, staffObject, staffKey }) {
  let alreadyAdded = false

  if (userContactData?.userId) {
    alreadyAdded = staffObject?.[staffKey]?.some((item) => item?.userId === userContactData?.userId)
  } else if (userContactData?.email) {
    alreadyAdded = staffObject?.[staffKey]?.some((item) => item?.email === userContactData?.email)
  } else if (userContactData?.mobile) {
    alreadyAdded = staffObject?.[staffKey]?.some((item) => item?.mobile === userContactData?.mobile)
  }
  return alreadyAdded
}
